/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useState } from 'react';
import { Box, Button, Col, CustomMenu, FabButton, FloatingMenu, ItemTypes, Row, SvgIcon, theme } from '@agilize/components-core';
import { logout } from '@services/auth/Auth';
import { Link, useHistory, Redirect } from 'react-router-dom';
import { ChildrenStyles } from '@components/mainContainer/MainContainer.styles';
import { useIntersectionObserver } from '@utils/hooks/useIntersectionObserver';
import { CompaniesContext } from '@context/CompaniesContext';
import Cookies from 'js-cookie';
import useScript from '@utils/hooks/useScript';
import HelpButton from '@components/helpButton/HelpButton';
import TourContainer from '@components/tourContainer/TourContainer';
import { P, spotlightStyles, Strong, StyledBox, StyledCompanyHeader, StyledHeader, WhiteButton } from './MainHeader.styles';
import { MainHeaderProps, USER_OPTIONS } from './MainHeader.types';
import ModalMenu from './ModalMenu/ModalMenu';

const MainHeader = (props: MainHeaderProps) => {
  const { activeMenu, toggleMenu } = props;
  const [ref, { isVisible: isTopOfPage }] = useIntersectionObserver({ threshold: 0, startVisible: true });
  const [toggleMenuModal, setToggleMenuModal] = useState(false);
  const { companies, selectedCompany, setSelectedCompany } = useContext(CompaniesContext);
  const history = useHistory();

  useScript('https://webcomponents.agilize.com.br/menu-apps/bundle.js');
  const handleToggleMenu = event => {
    toggleMenu();
    event.stopPropagation();
  };

  const handleToggleModalMenu = () => {
    setToggleMenuModal(!toggleMenuModal);
  };

  const userOptions = [
    {
      title: 'Minha conta',
      action: USER_OPTIONS.PROFILE,
    },
    { title: <Box color={theme.colors.red700}>Sair</Box>, action: USER_OPTIONS.LOGOUT, inSeparator: true },
  ];
  const handleActions = (action: string) => {
    if (action === USER_OPTIONS.LOGOUT) {
      logout();
    }
    if (action === USER_OPTIONS.PROFILE) {
      window.location.href = `${process.env.LOGIN_APP}/realms/${process.env.REALM}/account/`;
    }
  };

  const handleChangeCompany = company => {
    const isProductionOrStagingEnv = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging';
    Cookies.set('selectedCompanyId', company.id, isProductionOrStagingEnv && { domain: 'agilize.com.br' });
    (window as any).personId = company.id;
    const fullSelectedCompany = companies.find(companyItem => companyItem.id === company.id);
    setSelectedCompany(fullSelectedCompany);
    const isNotInDashboard = history.location.pathname !== '/';
    if (isNotInDashboard) {
      return history.push('/');
    }
    window.location.reload();
  };

  const formattedCompanies: ItemTypes[] =
    (companies &&
      companies.map(company => ({
        id: company.id || '',
        label: company.razaoSocial || '',
        icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/building.svg`} fill="purple700" width={20} height={20} />,
      }))) ||
    [];

  const formattedSelectedCompany = formattedCompanies.find(company => company.id === selectedCompany?.id);

  return (
    <>
      <div ref={ref} />
      <WhiteButton active={activeMenu}>
        <FabButton
          onClick={handleToggleMenu}
          iconPath={`${process.env.APP_PATH}public/assets/icons/custom/menu.svg`}
          iconColor="purple700"
          disabledBackgroundColor
        />
      </WhiteButton>
      <StyledHeader active={!isTopOfPage}>
        <ChildrenStyles>
          <Box as={Row} width="100%" noGutter>
            <Col small={8} medium={8} large={8} noGutter>
              <Box display="flex" alignItems="center" height="100%">
                <StyledCompanyHeader>
                  <agz-menu-apps current="rh" />
                </StyledCompanyHeader>
              </Box>
            </Col>
            <Col small={8} medium={8} large={8} noGutter>
              <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                <Button type="button" as={Link} to="/" variant="text">
                  <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/agz.svg`} height={30} width={30} />
                </Button>
              </Box>
            </Col>
            <Col small={8} medium={8} large={8} noGutter alignSelf="center">
              <Box display="flex" alignItems="center" justifyContent="flex-end" height="100%">
                <TourContainer
                  maxWidth={250}
                  spotlightStyles={spotlightStyles}
                  message={
                    <Box>
                      <p>
                        <Strong>Novo menu de ajuda</Strong>
                      </p>
                      <P>Precisa falar conosco? Clique em "Ajuda" para ver as opções.</P>
                    </Box>
                  }
                  tourId="helperButton"
                  target="helperButton"
                  defaultOpen>
                  <HelpButton />
                </TourContainer>
                <StyledBox className="hide-mobile" display="flex" alignItems="center">
                  {formattedSelectedCompany && companies.length > 0 && (
                    <CustomMenu items={formattedCompanies} selectedItem={formattedSelectedCompany} onClick={handleChangeCompany} />
                  )}
                  <FloatingMenu
                    icon={`${process.env.APP_PATH}public/assets/icons/unicons/user.svg`}
                    size="default"
                    options={userOptions}
                    hasOptionSeparator
                    itemHeight={48}
                    itemWidth={150}
                    placement="bottom-end"
                    handleOptionClick={data => handleActions(data)}
                  />
                </StyledBox>
                <FabButton
                  iconPath={`${process.env.APP_PATH}public/assets/icons/custom/menu-ellipses.svg`}
                  onClick={handleToggleModalMenu}
                  className="hide-desktop"
                />
              </Box>
            </Col>
          </Box>
        </ChildrenStyles>
        <ModalMenu
          isOpen={toggleMenuModal}
          onClose={handleToggleModalMenu}
          active="Recursos Humanos"
          formattedCompanies={formattedCompanies}
          formattedSelectedCompany={formattedSelectedCompany!}
          handleChangeCompany={handleChangeCompany}
        />
      </StyledHeader>
    </>
  );
};

export default MainHeader;
